// EFC Context Mark
export const typeOfEfcApplicationOptions = [
  { label: 'EN 15509', value: '0' },
  { label: 'GNSS', value: '1' },
  { label: 'PISTA', value: '2' },
  { label: 'UNI 10607-2', value: '3' },
];

export const booleanOptions = [
  { label: 'true', value: 'true' },
  { label: 'false', value: 'false' },
];

export const securityLevelOptions = [
  { label: 'secLevel0 - No use of access credentials', value: '0' },
  { label: 'secLevel1 - Security level 1 according to EN ISO 14906 (Triple DES)', value: '1' },
  { label: 'secLevel2 - Security level 2 according to EN ISO 14906 (AES)', value: '2' },
];

// Audit Log
export const eventSeverityOptions = [
  // Hiding Debug and Trace from users since we don't think it's used
  // { label: 'Trace', value: '0' },
  // { label: 'Debug', value: '1' },
  { label: 'Information', value: '2' },
  { label: 'Warning', value: '3' },
  { label: 'Error', value: '4' },
  { label: 'Critical', value: '5' },
  { label: 'None', value: '6' },
];

// OBE
export const obeStatusOptions = [
  { label: 'OK', value: 'OK' },
  { label: 'Warning', value: 'Warning' },
  { label: 'Error Contractual', value: 'Error Contractual' },
  { label: 'Error Technical', value: 'Error Technical' },
  { label: 'Fatal Error', value: 'Fatal Error' },
];

export const obeConnectivityStatus = [
  { label: 'Connected', value: 'CONNECTED' },
  { label: 'Disconnected', value: 'DISCONNECTED' },
];

// Toll Charger
export const tollSchemeOptions = [
  { label: 'DSRC', value: 'dsrc' },
  { label: 'ANPR', value: 'anpr' },
  { label: 'Hybrid (DSRC + ANPR)', value: 'hybrid' },
  { label: 'GNSS', value: 'gnss' },
];

export const agreementLineTypeOptions = [
  { label: 'Bizz', value: 'BIZZ' },
  { label: 'License plate number', value: 'LPN' },
];

export const agreementLineStatusOptions = [
  { label: 'Active', value: 'Active' },
  { label: 'Blocked', value: 'Blocked' },
  { label: 'Closed', value: 'Closed' },
];

export const entityTypeOptions = [
  { label: 'Toll Charger', value: '1' },
  { label: 'Toll Service Provider', value: '2' },
];

export const typeOfPanOptions = [
  { label: 'PAN1', value: '1' },
  { label: 'PAN2', value: '2' },
];
